import { z } from "zod";

export const zodErrorMap: z.ZodErrorMap = (issue, ctx) => {
  const path = issue.path.map((value, index, arr) => {
    if (typeof value !== 'number') return value;
    arr[index - 1] = `${arr[index - 1]}[${value}]`;
    return '';
  }).filter(value => value !== '').join('.');
  return { message : `${ctx.defaultError} in ${path}` };
}

export const formatZodError = (err: z.ZodError) => {
  return err.issues.map(issue => {
    return issue.message;
  }).join('\n');
}
